(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FirebaseTokenDeleteController',FirebaseTokenDeleteController);

    FirebaseTokenDeleteController.$inject = ['$uibModalInstance', 'entity', 'FirebaseToken'];

    function FirebaseTokenDeleteController($uibModalInstance, entity, FirebaseToken) {
        var vm = this;

        vm.firebaseToken = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FirebaseToken.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
